<div *ngIf="communications?.length > 0 else noCommunication" class="card bg-card-new card-radius-x1 border-0">
    <div class="card-header">
        <h5>{{"messages"|translate}}</h5>
    </div>
    <div class="card-divider"></div>
    <div class="card-table">
        <div class="table-responsive-sm">
            <table>
                <thead>
                    <tr>
                        <th>{{"name"|translate}}</th>
                        <th>{{"company"|translate}}</th>
                        <th>{{"date"|translate}}</th>
                    </tr>
                </thead>
                <tbody>
                    <tr style="cursor: pointer;" (click)="viewMessage(item)" *ngFor="let item of communications">
                        <td>{{user?.name}}</td>
                        <td>{{ translateHelper.localize(item.companyData?.name) }}</td>
                        <td>{{ item.timestamp |date }}</td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
    <div *ngIf="paginationMessageCount > 1">
        <div class="card-divider"></div>
        <div class="card-footer">
            <app-pagination (pageChange)="updateList($event)" [total]="paginationMessageCount"></app-pagination>
        </div>
    </div>
</div>
<ng-template #noCommunication>
    <div>
        {{"no_messages"|translate}}
    </div>
</ng-template>
